import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const { Title, Text } = Typography;

const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { login } = useAuth();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await login(values.email, values.password);
            message.success('Welcome back!');
            setTimeout(() => navigate('/'), 500);
        } catch (error) {
            message.error(error.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-login-container">
            {/* Subtle Background */}
            <div className="min-bg"></div>

            {/* Login Card */}
            <div className="min-login-card">
                {/* Logo */}
                <div className="min-logo">
                    <img src="/coop.png" alt="COOP Logo" className="coop-logo" />
                </div>

                {/* Title */}
                <Title level={2} className="min-title">Agri Inventory</Title>
                <Text className="min-subtitle">Palay & Marketing Cooperative</Text>

                {/* Form */}
                <Form
                    form={form}
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    className="min-form"
                >
                    {/* Email */}
                    <Form.Item
                        name="email"
                        rules={[
                            { required: true, message: 'Email is required' },
                            { type: 'email', message: 'Invalid email' }
                        ]}
                    >
                        <Input
                            placeholder="Email"
                            className="min-input"
                            size="large"
                        />
                    </Form.Item>

                    {/* Password */}
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Password is required' }]}
                    >
                        <Input.Password
                            placeholder="Password"
                            className="min-input"
                            size="large"
                        />
                    </Form.Item>

                    {/* Submit */}
                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            block
                            size="large"
                            className="min-button"
                        >
                            {loading ? 'Logging in' : 'Log In'}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default LoginPage;



